import type { ComponentProps, ReactNode } from "react";

import { cn } from "../../lib/cn";

/** Quiet text action for the right side of a CardHeader; put it on a <button> or a router <Link>. */
export const cardActionClassName =
	"text-caption text-ink-3 hover:text-ink bg-transparent border-0 cursor-pointer font-sans transition-colors";

export function Card({ className, ...props }: ComponentProps<"div">) {
	return <div className={cn("card-face overflow-hidden rounded-card border border-line", className)} {...props} />;
}

export interface CardHeaderProps {
	readonly title: string;
	/** Usually a <button> or <Link> styled with `cardActionClassName`. */
	readonly action?: ReactNode;
}

/** Card headers are a 10.5px uppercase eyebrow + an optional quiet action. */
export function CardHeader({ title, action }: CardHeaderProps) {
	return (
		<div className="flex items-center justify-between border-b border-line px-4 py-[13px]">
			<h2 className="text-label font-semibold tracking-caps text-ink-3 uppercase">{title}</h2>
			{action}
		</div>
	);
}
